// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
/* eslint-disable
    react/prefer-stateless-function
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React from 'react';

import DataConnector from 'connect/DataConnector';
import * as CrisprConstants from 'constants/CRISPRConstants';
import {CRISPRVector} from 'constants/CRISPRConstants';

import CompletedAssemblyStep from './CompletedAssemblyStep';
import CRISPRAssemblyStore, {CRISPRAssemblyState} from './CRISPRAssemblyStore';
import FinalizeAssembliesStep from './FinalizeAssembliesStep';
import SelectVectorStep from './SelectVectorStep';

const {ASSEMBLY_STEP} = CrisprConstants;

export class CRISPRAssemblyOptions extends React.Component {
  override render(): JSX.Element {
    return <ul className="nav navbar-nav form-inline" />;
  }
}

class CRISPRAssemblyTabConnector extends DataConnector<
  CRISPRAssemblyTabProps,
  CRISPRAssemblyTabEnhancedProps
> {
  override shouldSubscribeToRedux = false;
  override stores = [CRISPRAssemblyStore];

  enhanceProps(): CRISPRAssemblyTabEnhancedProps {
    return {
      ...this.crisprAssemblyStore().getAssemblyState(this.props.assemblyCid),
      ...this.crisprAssemblyStore().getState(),
    };
  }
}

interface CRISPRAssemblyTabProps {
  assemblyCid: string;
  sequenceName: string;
}
interface CRISPRAssemblyTabEnhancedProps extends CRISPRAssemblyState {
  vectors: Array<CRISPRVector>;
  vectorLoading: boolean;
}

class CRISPRAssemblyTab extends React.Component<CRISPRAssemblyTabProps & CRISPRAssemblyTabEnhancedProps> {
  override render(): JSX.Element {
    return (
      <div>
        {(() => {
          switch (this.props.step) {
            case ASSEMBLY_STEP.SELECT_VECTOR:
              return (
                <SelectVectorStep
                  assemblyCid={this.props.assemblyCid}
                  vectors={this.props.vectors}
                  vectorLoading={this.props.vectorLoading}
                  biojsSequence={this.props.biojsSequence}
                  enzyme={this.props.enzyme}
                  existingSequenceInputState={this.props.existingSequenceInputState}
                  fileInputState={this.props.fileInputState}
                  finalizingSelectedVector={this.props.finalizingSelectedVector}
                  // @ts-expect-error: unclear if values are allowed to be null or not at this point
                  insertionRegion={this.props.insertionRegion}
                  vectorSelectorState={this.props.vectorSelectorState}
                  vectorSourceType={this.props.vectorSourceType}
                />
              );
            case ASSEMBLY_STEP.FINALIZE_ASSEMBLIES:
              return (
                <FinalizeAssembliesStep
                  analysis={this.props.analysis}
                  assemblyCid={this.props.assemblyCid}
                  assemblies={this.props.assemblies}
                  assembliesFolder={this.props.assembliesFolder}
                  finalizingAssemblies={this.props.finalizingAssemblies}
                />
              );
            case ASSEMBLY_STEP.COMPLETED_ASSEMBLY:
              return (
                <CompletedAssemblyStep
                  assemblyCid={this.props.assemblyCid}
                  assemblyPrimers={this.props.assemblyPrimers}
                  sequenceName={this.props.sequenceName}
                />
              );
            default:
              return null;
          }
        })()}
      </div>
    );
  }
}

export const ConnectedCRISPRAssemblyTab = CRISPRAssemblyTabConnector.connect(CRISPRAssemblyTab);
